<template>
  <div v-if="!loading">
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Skóre
            </th>
            <th class="text-left">
              Typ
            </th>
            <th class="text-left">
              Stav
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in crasOpened"
            :key="item.id"
          >
            <td>{{ item.score }}</td>
            <td>{{ item.type }}</td>
            <td>{{ item.closed }}</td>
          </tr>
          <tr
            v-for="item in crasClosed"
            :key="item.id"
          >
            <td>{{ item.score }}</td>
            <td>{{ item.type }}</td>
            <td>{{ item.closed }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
  <div v-else>
    <v-skeleton-loader
      class="mx-auto"
      type="table"
    />
  </div>
</template>


<script>
import { APIService } from "@/http/APIService.js";

const apiService = new APIService();

export default {
  name: "Cra",

  props: {
    id: { type: String, required: true },
  },

  data: () => ({
    masterLoading: [true, true],
    crasOpened: [],
    crasClosed: [],
  }),

  computed: {
    loading() {
      return this.masterLoading.some(Boolean);
    },
  },

  watch: {},
  mounted() {
    this.getData(this.id);
  },

  methods: {
    getData(id) {
      this.$set(this.masterLoading, 0, true);
      apiService
        .getCraForms("-id", "", 5, 0, [
          ["prisoner", id],
          ["closed", false],
        ])
        .then((response) => {
          this.crasOpened = response.results;
          this.$set(this.masterLoading, 0, false);
        });

      this.$set(this.masterLoading, 1, true);
      apiService
        .getCraForms("-id", "", 5, 0, [
          ["prisoner", id],
          ["closed", true],
        ])
        .then((response) => {
          this.crasClosed = response.results;
          this.$set(this.masterLoading, 1, false);
        });
    },
  },
};
</script>